var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-scrollable",style:(_vm.styles)},[_c('vue-scroll',{ref:"scroll",on:{"handle-scroll":_vm.onScroll}},[_c('div',{ref:"content",staticClass:"v-scrollable__inner"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }